"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DSTL001_Submit_View = void 0;
const throttle_1 = __importDefault(require("lodash/throttle"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const styled_components_1 = __importStar(require("styled-components"));
const GlobalStateProvider_1 = require("../../../GlobalStateProvider");
const common_1 = require("../../../common");
const server_1 = require("../../../server");
const account_1 = require("../../base/account");
const SurveyContainer_1 = require("../../base/layout/Survey/SurveyContainer");
const popup_1 = require("../../base/popup");
const DSTL001_View_Child_1 = require("./component/DSTL001_View_Child");
const AttachFileContainer_1 = require("../../DSS/DSSL001/DSSL001_Detail_Child/AttachFileContainer");
const DSTL001ViewStyled = styled_components_1.default.div `
	width: 100%;
	display: flex;
	flex-direction: column;
	height: 100%;
	overflow: ${props => (props.$isMobile ? 'hidden' : props.$isDetail ? 'unset' : 'auto')};
	gap: ${props => (props.$isMobile ? '24px' : 'unset')};
	${props => props.$isMobile && 'padding: 10px 20px;'};

	&.hidetitle {
		height: 100%;
		flex: 1;
	}

	input:disabled,
	textarea:disabled {
		background: var(--color-white, #ffffff);
	}

	.field-short {
		border-style: solid;
		border-color: var(--color-silver, #f3f4f8);
		border-width: 0px 0px 1px 0px;
		padding: 0px 0px 20px 0px;
		display: flex;
		flex-direction: row;
		gap: 12px;
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
	}

	.errataTable_wrap {
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		height: 100%;

		.score {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 1px 0px 0px 0px;

			padding: 20px 0px 20px 0px;
			display: flex;
			flex-direction: row;
			gap: 4px;
			align-items: center;
			justify-content: center;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;

			${props => props.$isMobile
    ? (0, styled_components_1.css) `
							.label {
								color: var(--color-grey-d, #4d4d4d);
								text-align: right;
								font-family: 'Noto Sans KR', sans-serif;
								font-size: 16px;
								line-height: 150%;
								letter-spacing: -0.02em;
								font-weight: 700;
								position: relative;
								text-overflow: ellipsis;
								overflow: hidden;
								white-space: nowrap;
							}
							.value {
								color: #f46790;
								text-align: right;
								font-family: 'Noto Sans KR', sans-serif;
								font-size: 20px;
								line-height: 150%;
								letter-spacing: -0.02em;
								font-weight: 700;
								position: relative;
								text-overflow: ellipsis;
								overflow: hidden;
								white-space: nowrap;
							}
					  `
    : (0, styled_components_1.css) `
							height: 100px;

							.label {
								color: var(--color-grey-d, #4d4d4d);
								text-align: right;
								font-family: var(--h3-font-family, 'Noto Sans KR', sans-serif);
								font-size: var(--h3-font-size, 24px);
								line-height: var(--h3-line-height, 36px);
								font-weight: var(--h3-font-weight, 700);
								position: relative;
								text-overflow: ellipsis;
								overflow: hidden;
								white-space: nowrap;
							}
							.value {
								color: #f46790;
								text-align: right;
								font-family: var(--h3-font-family, 'Noto Sans KR', sans-serif);
								font-size: var(--h3-font-size, 24px);
								line-height: var(--h3-line-height, 36px);
								font-weight: var(--h3-font-weight, 700);
								position: relative;
								text-overflow: ellipsis;
								overflow: hidden;
								white-space: nowrap;
							}
					  `}

			.fixed {
				color: #f46790;
				text-align: right;
				font-family: var(--h3-font-family, 'Noto Sans KR', sans-serif);
				font-size: var(--h3-font-size, 24px);
				line-height: var(--h3-line-height, 36px);
				font-weight: var(--h3-font-weight, 700);
				position: relative;
				text-overflow: ellipsis;
				overflow: hidden;
				white-space: nowrap;
			}
		}
	}

	&.hidetitle {
		.errataTable_wrap {
			margin-top: 12px;
		}
	}

	.btn_default {
		margin-top: 36px;
	}

	.no_submit_wrap {
		width: 100%;
		justify-content: center;
		align-items: center;
		display: flex;
		color: var(--color-grey-l, #83868a);
		text-align: left;
		font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--b3-font-size, 16px);
		line-height: var(--b3-line-height, 32px);
		font-weight: var(--b3-font-weight, 400);
		position: relative;
		height: ${props => (props.$isTablet ? '100%' : undefined)};
	}

	.name-tag-info {
		gap: 12px;
		display: flex;
		flex-direction: column;
	}

	.att_submit_view {
		display: flex;
		flex-direction: column;
		gap: 12px;
		flex: 1;
	}

	.feedback-submit-button {
		display: flex;
		justify-content: flex-end;
	}

	.feedback-file {
		display: flex;
		flex-direction: column;
		gap: 12px;
	}

	.submit-false {
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.survey_option_detail {
		display: none;

		.radio_wrap {
			label {
				> span {
					margin-left: 6px;
					font-size: 12px;
					line-height: 1.41;
					letter-spacing: -0.01em;
				}
			}

			.mark {
				background: var(--color-grey-c);
				border-color: var(--color-grey-c);
			}
		}

		.chk_wrap {
			label {
				> span {
					margin-left: 6px;
					font-size: 12px;
					line-height: 1.41;
					letter-spacing: -0.01em;
				}
			}
		}
	}

	.survey_option_detail.active {
		display: block;
	}

	.survey_option_detail[survey-option='1'].active {
		display: flex;
		flex-direction: column;
		flex-wrap: wrap;
		gap: 5px 20px;
	}

	.survey_option_detail[survey-option='4'].active {
		display: flex;
		flex-direction: column;
		flex-wrap: wrap;
		gap: 5px 20px;
	}

	.survey-submit-view {
		// height: calc(100% - 70px);
		gap: 12px;
		display: flex;
		flex-direction: column;
		padding: 10px;
	}

	.survey-table {
		width: 100%;
		border-collapse: collapse;
	}

	.survey-table th,
	.survey-table td {
		font-weight: 400;
		padding: 10px;
		border-style: solid;
		border-color: var(--color-silver, #f3f4f8);
		border-width: 0px 0px 1px 0px;
	}

	.survey-data-header {
		background: var(--color-silver, #f3f4f8);
		border-style: solid;
		border-color: var(--color-grey-w, #b6bac0);
		border-width: 1px 0px 0px 0px;
		position: relative;
		width: 100%;
	}

	.survey-data-header th {
		background: var(--color-silver, #f3f4f8);
		border-style: solid;
		border-color: var(--color-grey-w, #b6bac0);
		border-width: 1px 0px 0px 0px;
	}

	.count-column {
		width: 50px;
		text-align: center;
	}

	.survey-table td,
	.survey-table th {
		white-space: nowrap; /* Prevents text from wrapping to the next line */
		overflow: hidden; /* Hides the overflow content */
		text-overflow: ellipsis; /* Adds ellipsis (…) for overflow text */
	}

	.survey-table td {
		white-space: nowrap; /* Prevents text from wrapping */
		overflow: hidden; /* Hides overflow content */
		text-overflow: ellipsis; /* Adds ellipsis for overflow text */
		max-width: 200px; /* Set a max width for the cells, adjust as needed */
	}

	.survey-title {
		display: flex;
		align-items: center;
		width: 100%; /* Adjust the width if needed */
	}

	.survey-result {
		padding: 20px 20px 20px 20px;
		border-radius: 0px 0px 8px 8px;
		border-style: solid;
		border-color: var(--color-silver, #f3f4f8);
		border-width: 0px 1.5px 1.5px 1.5px;
	}
`;
// 제출 결과 테이블
const count = 20;
exports.DSTL001_Submit_View = react_1.default.memo(({ hideTitle = false, test_id, member, subjectId = '', isDetail = false, isPreview = false, isSurvey = false, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isTablet, isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const [testInfo, setTestInfo] = (0, react_1.useState)();
    const [score, setScore] = (0, react_1.useState)(0); // 총점 조회
    const [submitted, setSubmitted] = (0, react_1.useState)(false);
    // const postFeedbackMutation = useMutation(postFeedback);
    const { member_id, member_name } = (0, react_1.useMemo)(() => {
        return { member_id: member?.id || '', member_name: member?.name };
    }, [member]);
    const isTeacher = (0, react_redux_1.useSelector)((state) => (0, account_1.getIsTeacher)(state));
    // 과제 정보 조회
    const { data, refetch } = (0, server_1.useAssignmentList)({ id: test_id, survey: isSurvey });
    // 제출 현황 정보 조회
    const { data: statisticData, refetch: statisticRefetch } = (0, server_1.useSubmitStatus)({
        id: test_id,
        member_id,
        subject_item: subjectId,
        offset: 0,
        limit: 1,
    });
    const refetchList = (0, throttle_1.default)(() => {
        refetch();
    }, 1000, { leading: true, trailing: false });
    const refetchStatisticList = (0, throttle_1.default)(() => {
        statisticRefetch();
    }, 1000, { leading: true, trailing: false });
    (0, react_1.useEffect)(() => {
        if (!hideTitle && test_id)
            refetchList();
        if (test_id)
            refetchStatisticList();
    }, [hideTitle, test_id, member]);
    (0, react_1.useEffect)(() => {
        if (!data)
            return;
        const { total_count, items } = data;
        if (total_count >= 1) {
            setTestInfo(items[0]);
        }
    }, [data]);
    (0, react_1.useEffect)(() => {
        if (!statisticData)
            return;
        const { total_count, items, total_score } = statisticData;
        if (!member_id) {
            setScore(total_score);
            setSubmitted(true);
            return;
        }
        if (total_count >= 1) {
            const memberItem = items.find(item => item.member_id === member_id);
            const score = member_id !== '' ? memberItem?.score || 0 : total_score;
            const submitted = memberItem ? (memberItem?.not_submitted ? false : true) : false;
            setScore(score === -1 ? 0 : score);
            setSubmitted(submitted);
        }
        else {
            setScore(0);
            setSubmitted(false);
        }
    }, [statisticData, member_id, subjectId]);
    const hidePopup = () => {
        APP.eventManager.publish(popup_1.TOGGLE_POPUP);
    };
    const test_type = (0, react_1.useMemo)(() => testInfo
        ? testInfo.type +
            `${testInfo.type === 'OMR' && testInfo.subject !== ''
                ? ' - ' + t(`assignment.${testInfo.subject}`)
                : ''}`
        : '', [testInfo]);
    const renderSurveyContent = () => {
        return (react_1.default.createElement(SurveyContainer_1.SurveyContainer, { isPreview: isPreview, item: testInfo, test_id: test_id, member_id: member_id, submitted: submitted }));
    };
    const renderFileAttachmentContent = () => {
        return (react_1.default.createElement("div", { className: "att_submit_view" },
            react_1.default.createElement(AttachFileContainer_1.AttachFileContainer, { isPreview: isPreview, item: testInfo, test_id: test_id, member_id: member_id, submitted: submitted })));
    };
    const renderOmrContent = () => {
        return (react_1.default.createElement("div", { className: "errataTable_wrap" },
            !hideTitle && (react_1.default.createElement("div", { className: "score" },
                react_1.default.createElement("div", { className: "label" }, t('assignment.allScore')),
                react_1.default.createElement("div", { className: "value" }, t('assignment.scoreValue', { score })))),
            react_1.default.createElement(DSTL001_View_Child_1.ErrataTable, { subject_id: subjectId, subject_name: testInfo.subject, isDetail: !!member_id, test_id: test_id, member_id: member_id, isTeacher: isTeacher }),
            !hideTitle && !isMobile && !isTeacher && (react_1.default.createElement(common_1.Button, { className: "btn_default xmd", text: "common.complete", onClick: hidePopup }))));
    };
    if (!testInfo) {
        return (react_1.default.createElement(DSTL001ViewStyled, { "$isDetail": isDetail, "$isTablet": isTablet, "$isMobile": isMobile }, t('assignment.noAssignment')));
    }
    return (react_1.default.createElement(DSTL001ViewStyled, { "$isDetail": isDetail, "$isTablet": isTablet, "$isMobile": isMobile, className: `${hideTitle ? 'hidetitle' : ''}` },
        hideTitle ? (react_1.default.createElement("div", { className: "score-title" }, hideTitle && !member_id
            ? t('assignment.scoreStatus2')
            : t('assignment.scoreStatus', { score, member_name }))) : (react_1.default.createElement(DSTL001_View_Child_1.NameTagContainer, { test_type: test_type, member_name: member_name })),
        testInfo.type === '설문형'
            ? renderSurveyContent()
            : testInfo.type === '파일첨부형'
                ? renderFileAttachmentContent()
                : renderOmrContent()));
});
